import { Typography } from "@mui/material";
import {  ReadMore } from "components/atoms";
import { DataGridColumnHeader, TableContainer } from "components/ui";
import React, { useEffect, useState } from "react";
import GlobalPagination from "utils/GlobalPagination";

const ModalCheckInSummary = ({ data }) => {
  const [filterObj, setFilterObj] = useState(null);

  useEffect(() => {
    setFilterObj({
      page: 1,
      pageSize: GlobalPagination.pageSize,
    });
  }, []);

  const columns = [
    {
      id: "id",
      accessorKey: "No.",
      accessorFn: (row) => row.is_active,
      header: ({ column }) => (
        <div className="flex justify-center ">
          <DataGridColumnHeader title="No." column={column} />
        </div>
      ),
      enableColumnFilter: false,
      enableSorting: false,

      cell: ({ row }) => (
        <div className="flex justify-center">
          <Typography variant="p">{filterObj?.page * row.index + 1}</Typography>
        </div>
      ),
      size: 50,
    },

    {
      id: "answers",
      accessorFn: (row) => row.answers,
      header: ({ column }) => (
        <DataGridColumnHeader title="Answer" column={column} />
      ),

      enableSorting: false,
      size: 280,
      meta: {
        headerClassName: "",
      },
      accessorKey: "summary",
      enableColumnFilter: false,
      cell: ({ row }) => {
        const data = row?.original?.answers;

        return (
          <span className="text-foreground font-normal capitalize max-w-full break-all">
            <ReadMore comment={data || "N/A"} maxChar={150} />
          </span>
        );
      },
    },
  ];

  return (
    <div className="Vehicle-brand-page">
      {
        <div className="mt-4">
          <TableContainer
            columns={columns}
            isGlobalFilter={false}
            isPagination={true}
            onUpdatePagination={(size, page) => {
              setFilterObj((prev) => ({ ...prev, page: page, pageSize: size }));
            }}
            paginationState={{
              pageIndex: filterObj?.page - 1,
              pageSize: filterObj?.pageSize,
            }}
            recordCount={data?.total}
            data={data ?? []}
            title="Summary Answers"
            totalPages={data?.totalPages}
          />
        </div>
      }
    </div>
  );
};

export default ModalCheckInSummary;
